import React, { Component } from 'react';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';

import MainIndex from '../components/MainIndex';
import Auth from '../components/Auth';
import OidcApp from '../components/OidcApp';
import Logout from '../components/Logout';
import './App.scss';

class App extends Component {
  render() {
    return (
      <Router>
        <div className="App-container">
          <Switch>
            <Route exact path="/" component={MainIndex} />
            <Route exact path="/oidcapp" component={OidcApp} />
            <Route path="/auth" component={Auth} />
            <Route path="/logout" component={Logout} />
          </Switch>
        </div>
      </Router>
    );
  }
}

export default App;
